<template>
  <div class="page-notice page-content" v-loading="body_loading">
    <div class="main-body">
      <el-row class="hd">
        <el-col :span="12">
          <h3 style="float: none;">消息通知</h3>
          <div class="flex-block breadcrumb-box">
            <div class="position-text">位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>消息通知</el-breadcrumb-item>
              <el-breadcrumb-item>消息通知</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
          <el-button type="primary" class="btn-bg-p" @click="handleNotice('add')">
            添加 <i class="el-icon-plus"></i>
          </el-button>
        </el-col>
      </el-row>
      <div class="bd">
        <div class="search-block content-body">
          <el-form
            :inline="true"
            ref="formSearch"
            :model="form_search"
            class="demo-form-inline"
            @submit.native.prevent
          >
<!--            <el-form-item prop="title" label="标题：" style="margin-bottom: 0;">
              <el-input
                v-model="form_search.title"
                size="small"
                placeholder="请输入标题"
                clearable
              ></el-input>
            </el-form-item>-->
            <el-form-item prop="toUserId" label="接收人：" style="margin-bottom: 0;">
              <el-select
                size="small"
                clearable
                filterable
                v-model="form_search.toUserId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in all_user_list"
                  :key="item.icode"
                  :label="item.userName"
                  :value="item.icode"
                ></el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item label="日期：">
              <el-date-picker
                size="small"
                clearable
                v-model="create_range"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>-->
            <el-form-item style="margin-bottom: 0;">
              <el-button type="primary" class="search-btn" size="medium" @click="searchList">
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-block content-body">
          <div ref="contentBody">
            <el-table
              ref="multipleTable"
              :data="table_data.list"
              v-loading="table_data.loading"
              tooltip-effect="dark"
              style="width: 100%; text-align: center;"
            >
              <el-table-column prop="title" label="标题" min-width="160" align="center"></el-table-column>
              <el-table-column prop="toUserName" label="接收人" min-width="200" align="center">
                <template slot-scope="scope">
                  <div class="recipients">{{ scope.row.toUserName }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="content" label="内容" min-width="220" align="center">
                <template slot-scope="scope">
                  <div class="table-html" v-html="scope.row.content"></div>
                </template>
              </el-table-column>
              <el-table-column prop="createUserName" label="创建人" min-width="120" align="center"></el-table-column>
              <el-table-column prop="createdate" label="创建时间" min-width="160" align="center"></el-table-column>
              <el-table-column prop="updatedate" label="更新时间" min-width="160" align="center"></el-table-column>
              <el-table-column prop="operating" label="操作" min-width="140" fixed="right" align="center">
                <template slot-scope="scope">
                  <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleNotice('edit', scope.row)">
                    编辑
                  </el-button>
                  <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteNotice(scope.row.icode)">
                    删除
                  </el-button>
                  <el-button class="option-btn btn-bd-p" type="primary" size="mini" @click="pushNotice(scope.row.icode)">
                    推送
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="table_data.page_info.pageNo"
            :page-sizes="[10, 30, 50, 80, 100]"
            :page-size="table_data.page_info.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="table_data.page_info.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-export goods-dialog"
      :title="dlg_notice.title"
      :visible.sync="dlg_notice.visible"
      width="1000px"
      @closed="closeNotice"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formNotice"
        :model="dlg_notice.form"
        label-width="120px"
        :rules="dlg_notice.rules"
        @submit.native.prevent
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="title" label="标题" :error="dlg_notice.error.title">
              <el-input size="small" v-model="dlg_notice.form.title" placeholder="请输入标题" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="toUserIdsArr" label="接收人" :error="dlg_notice.error.toUserId">
              <el-select
                size="small"
                v-model="dlg_notice.form.toUserIdsArr"
                placeholder="请选择接收人"
                multiple
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in all_user_list"
                  :key="item.icode"
                  :label="item.userName"
                  :value="String(item.icode)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="content" label="内容" :error="dlg_notice.error.content">
              <my-editor
                class="notice-editor"
                :content_text="dlg_notice.form.content"
                @update:content_text="onContentUpdate"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlg_notice.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitNotice" :loading="dlg_notice.btn_loading">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyEditor from '@/components/MyEditor/index.vue';

export default {
  name: 'noticeList',
  components: { MyEditor },
  data() {
    return {
      clientHeight: '',
      body_loading: false,
      create_range: '',
      all_user_list: [],
      pendingSelectAll: false,
      form_search: {
        title: '',
        toUserId: '',
        createdateStart: '',
        createdateEnd: ''
      },
      table_data: {
        loading: false,
        list: [],
        page_info: {
          pageNo: 1,
          pageSize: 30,
          total: 0
        }
      },
      dlg_notice: {
        id: '',
        visible: false,
        btn_loading: false,
        title: '',
        form: {
          icode: '',
          title: '',
          toUserId: '',
          toUserName: '',
          toUserIdsArr: [],
          content: '',
          createUserId: '',
          createUserName: '',
          createdate: '',
          updatedate: ''
        },
        error: {
          title: '',
          toUserId: '',
          content: ''
        },
        reset_form: {},
        rules: {
          title: { required: true, message: '请输入标题', trigger: ['change', 'blur'] },
          toUserIdsArr: { type: 'array', required: true, message: '请选择接收人', trigger: ['change', 'blur'] },
          content: { required: true, message: '请输入内容', trigger: ['change', 'blur'] }
        }
      }
    };
  },
  created() {
    document.title = '消息通知管理';
    this.initResetForm();
    this.getList();
    this.getAllUserList();
  },
  methods: {
    initResetForm() {
      this.dlg_notice.reset_form = JSON.parse(JSON.stringify(this.dlg_notice.form));
    },
    searchList() {
      this.table_data.page_info.page = 1;
      this.getList();
    },
    closeNotice() {
      Object.keys(this.dlg_notice.form).forEach((key) => {
        this.$set(this.dlg_notice.form, key, this.dlg_notice.reset_form[key]);
      });
      this.dlg_notice.form.toUserIdsArr = [];
      Object.keys(this.dlg_notice.error).forEach((key) => {
        this.dlg_notice.error[key] = '';
      });
      this.$nextTick(() => {
        if (this.$refs.formNotice) {
          this.$refs.formNotice.clearValidate();
        }
      });
    },
    handleNotice(type, row) {
      this.dlg_notice.visible = true;
      if (type === 'add') {
        this.dlg_notice.title = '添加通知';
        this.dlg_notice.id = '';
        this.resetDialogForm();
        this.selectAllRecipients();
      } else {
        this.dlg_notice.title = '编辑通知';
        this.dlg_notice.id = row.icode;
        this.fetchNoticeDetail(row.icode);
      }
    },
    resetDialogForm() {
      Object.keys(this.dlg_notice.reset_form).forEach((key) => {
        this.$set(this.dlg_notice.form, key, this.dlg_notice.reset_form[key]);
      });
      this.dlg_notice.form.toUserIdsArr = [];
    },
    fetchNoticeDetail(id) {
      this.body_loading = true;
      this.$client.get(
        '/api/biz/taili/notice/getModel',
        { icode: id },
        (res) => {
          this.body_loading = false;
          Object.keys(this.dlg_notice.form).forEach((key) => {
            this.$set(this.dlg_notice.form, key, res[key] || '');
          });
          this.dlg_notice.form.content = this.normalizeRichText(this.dlg_notice.form.content);
          this.dlg_notice.form.toUserIdsArr = this.parseIds(res.toUserId);
          if (!this.dlg_notice.form.toUserIdsArr.length) {
            this.selectAllRecipients();
          }
        },
        () => {
          this.body_loading = false;
        }
      );
    },
    onContentUpdate(val) {
      this.dlg_notice.form.content = this.normalizeRichText(val);
    },
    parseIds(value) {
      if (!value) {
        return [];
      }
      return value
        .split(',')
        .filter((id) => id)
        .map((id) => String(id));
    },
    selectAllRecipients() {
      if (this.all_user_list && this.all_user_list.length) {
        this.dlg_notice.form.toUserIdsArr = this.all_user_list.map((item) => String(item.icode));
        this.pendingSelectAll = false;
      } else {
        this.pendingSelectAll = true;
      }
    },
    submitNotice() {
      this.$refs.formNotice.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.dlg_notice.btn_loading = true;
        const selectedIds = (this.dlg_notice.form.toUserIdsArr || []).map((id) => String(id));
        const recipients = this.all_user_list.filter((item) =>
          selectedIds.includes(String(item.icode))
        );
        this.dlg_notice.form.toUserId = selectedIds.join(',');
        this.dlg_notice.form.toUserName = recipients.map((item) => item.userName).join(',');
        const payload = {
          ...this.dlg_notice.form
        };
        payload.content = this.normalizeRichText(payload.content);
        this.dlg_notice.form.content = payload.content;
        delete payload.toUserIdsArr;
        this.$client.post(
          '/api/biz/taili/notice/save',
          payload,
          (res, message) => {
            this.$message(message);
            this.getList();
            this.dlg_notice.btn_loading = false;
            this.dlg_notice.visible = false;
          },
          (message) => {
            this.dlg_notice.btn_loading = false;
            if (typeof message === 'object') {
              Object.keys(this.dlg_notice.error).forEach((key) => {
                this.dlg_notice.error[key] = message[key] || '';
              });
            }
          }
        );
      });
    },
    pushNotice(icode) {
      if (!icode) {
        this.$message.warning('请先选择通知记录');
        return;
      }
      this.$client.post(
        '/api/biz/taili/notice/showWindow',
        { icode },
        () => {
          this.$message.success('推送成功');
        },
        () => {
          this.$message.error('推送失败');
        }
      );
    },
    getAllUserList() {
      this.$client.get(
        '/api/sys/user/getListBoss',
        {},
        (res) => {
          this.all_user_list = res || [];
          if (this.pendingSelectAll) {
            this.selectAllRecipients();
          }
        },
        () => {}
      );
    },
    getList() {
      const params = {
        ...this.form_search,
        pageNo: this.table_data.page_info.page || this.table_data.page_info.pageNo,
        pageSize: this.table_data.page_info.pageSize
      };
      this.table_data.loading = true;
      this.$client.get(
        '/api/biz/taili/notice/getListForSecretary',
        params,
        (res, message, total) => {
          const list = res || [];
          this.table_data.list = list.map((item) => {
            const next = { ...item };
            next.content = this.normalizeRichText(next.content);
            return next;
          });
          this.table_data.page_info.total = total || 0;
          this.table_data.loading = false;
        },
        () => {
          this.table_data.loading = false;
        }
      );
    },
    deleteNotice(id) {
      this.$confirm('确定要删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'icon-delete el-icon-delete',
        customClass: 'my-confirm-box',
        center: true
      })
        .then(() => {
          this.$client.post(
            '/api/biz/taili/notice/delete',
            { icode: id },
            () => {
              this.getList();
            },
            () => {}
          );
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.table_data.page_info.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.table_data.page_info.page = val;
      this.getList();
    },
    changeFixed(clientHeight) {
      if (this.$refs.contentBody) {
        this.$refs.contentBody.style.minHeight = clientHeight - 394 + 'px';
      }
    },
    normalizeRichText(html) {
      if (!html || typeof html !== 'string') {
        return '';
      }
      const alignClassMap = {
        'ql-align-center': 'center',
        'ql-align-right': 'right',
        'ql-align-justify': 'justify',
        'ql-align-left': 'left'
      };
      const fontClassMap = {
        'ql-font-SimSun': 'SimSun',
        'ql-font-SimHei': 'SimHei',
        'ql-font-Microsoft-YaHei': '"Microsoft YaHei"',
        'ql-font-KaiTi': 'KaiTi',
        'ql-font-FangSong': 'FangSong',
        'ql-font-Arial': 'Arial',
        'ql-font-Times-New-Roman': '"Times New Roman"',
        'ql-font-sans-serif': 'sans-serif'
      };
      const container = document.createElement('div');
      container.innerHTML = html;
      const walker = (node) => {
        if (!node || !node.querySelectorAll) {
          return;
        }
        const elements = node.querySelectorAll('*');
        elements.forEach((el) => {
          if (!el.classList || el.classList.length === 0) {
            return;
          }
          Object.keys(alignClassMap).forEach((className) => {
            if (el.classList.contains(className) && !el.style.textAlign) {
              el.style.textAlign = alignClassMap[className];
              // el.classList.remove(className);
            }
          });
          const fontClass = Array.from(el.classList).find((cls) => fontClassMap[cls]);
          if (fontClass && !el.style.fontFamily) {
            el.style.fontFamily = fontClassMap[fontClass];
            // el.classList.remove(fontClass);
          }
          if (el.classList.contains('ql-align')) {
            // el.classList.remove('ql-align');
          }
          if (el.classList.contains('ql-font')) {
            // el.classList.remove('ql-font');
          }
        });
      };
      walker(container);
      return container.innerHTML;
    }
  },
  mounted() {
    this.clientHeight = `${document.documentElement.clientHeight}`;
    window.onresize = () => {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    clientHeight(val) {
      this.changeFixed(Number(val));
    },
    create_range(newVal) {
      if (!newVal) {
        this.form_search.createdateStart = '';
        this.form_search.createdateEnd = '';
      } else {
        this.form_search.createdateStart = newVal[0];
        this.form_search.createdateEnd = newVal[1];
      }
    }
  }
};
</script>

<style scoped>
.table-html {
  line-height: 1.4;
  text-align: left;
  max-height: 80px;
  overflow: hidden;
}
.recipients {
  line-height: 1.4;
  word-break: break-all;
}
.notice-editor ::v-deep .quill-editor {
  width: 100%;
  height: 320px !important;
}
.notice-editor ::v-deep .ql-toolbar {
  width: 100%;
}
.notice-editor ::v-deep .ql-container {
  min-height: 280px;
}
</style>
